var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M9.5,38.3c0.1,1,0.9,1.7,1.9,1.7h22.2c1,0,1.8-0.7,1.9-1.7V9.6c-0.1-1-0.9-1.8-1.9-1.7c0,0,0,0,0,0h-1.9 l-1-1.4h-0.3c-1,0.1-3.8,0.4-4.6,0.1l-0.6-0.7C24.9,5.4,24.6,5,24.1,5h-3.2c-0.5,0-0.8,0.4-1.1,0.9s-0.4,0.5-0.6,0.6s-3.6,0-4.6-0.1 h-0.3l-1,1.4h-1.9c-1-0.1-1.8,0.7-1.9,1.7c0,0,0,0.1,0,0.1V38.3z M14.7,7c0.8,0.1,3.7,0.4,4.8,0s0.5-0.5,0.8-0.8l0.6-0.6h3.2 l0.6,0.6C25,6.5,25.2,6.9,25.5,7s4,0.1,4.8,0c0.6,0.7,1.1,1.5,1.6,2.3H13.1C13.6,8.5,14.1,7.7,14.7,7z M11.4,8.4h1.5 c-0.3,0.6-0.5,1-0.4,1.2c0.1,0.2,0.3,0.3,0.5,0.3h19c0.2,0,0.4-0.1,0.5-0.3c0.1-0.2-0.1-0.6-0.4-1.2h1.5c0.7,0,1.2,0.5,1.3,1.2v28.7 c-0.1,0.7-0.6,1.2-1.3,1.1c0,0,0,0,0,0H11.4c-0.7,0.1-1.2-0.4-1.3-1.1c0,0,0,0,0,0V9.6C10.2,8.9,10.7,8.4,11.4,8.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M31.9,9.3c-0.5-0.8-1-1.6-1.6-2.3c-0.8,0.1-3.7,0.4-4.8,0c-1.1-0.4-0.5-0.5-0.8-0.8l-0.6-0.6h-3.2l-0.6,0.6 C20,6.5,19.8,6.9,19.5,7c-0.3,0.1-4,0.1-4.8,0c-0.6,0.7-1.1,1.5-1.6,2.3H31.9z M22.5,6.1c0.6,0,1.1,0.5,1.1,1.1c0,0,0,0,0,0 c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C21.4,6.6,21.9,6.1,22.5,6.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M10.1,38.3c0.1,0.7,0.6,1.2,1.3,1.1c0,0,0,0,0,0h22.2c0.7,0.1,1.2-0.4,1.3-1.1c0,0,0,0,0,0V9.6 c-0.1-0.7-0.6-1.2-1.3-1.2h-1.5c0.3,0.6,0.5,1,0.4,1.2c-0.1,0.2-0.3,0.3-0.5,0.3H13c-0.2,0-0.4-0.1-0.5-0.3 c-0.1-0.2,0.1-0.6,0.4-1.2h-1.5c-0.7,0-1.2,0.5-1.3,1.2V38.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.5,8.2c0.6,0,1-0.4,1.1-1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1C21.5,7.8,21.9,8.2,22.5,8.2z  M22.5,6.7c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5S22,7.5,22,7.2C22,6.9,22.2,6.7,22.5,6.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.5,7.6c0.2,0,0.5-0.2,0.5-0.4c0-0.3-0.2-0.5-0.5-0.5S22,6.9,22,7.2C22,7.4,22.3,7.6,22.5,7.6z"
});

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.c92faebe961b25af14caf7ff2fcde468.svg";
export { ForwardRef as ReactComponent };